/**
 * TASK instruments from V2 may return metadata with a nested `metadata` object
 * (scheduling / properties fields) alongside task-catalog envelope fields.
 * These helpers flatten to the single metadata shape used by the scheduler/editor.
 */

/** Task-catalog / API envelope keys — not part of standard instrument metadata. */
export const TASK_METADATA_ENVELOPE_KEYS = ['module', 'variant', 'description', 'type', 'id', 'title']

export const flattenTaskMetadata = (metadata = {}) => {
  if (!metadata || typeof metadata !== 'object') return {}

  const nested = metadata.metadata
  const hasNested = nested && typeof nested === 'object' && !Array.isArray(nested)

  if (!hasNested) {
    const copy = { ...metadata }
    delete copy.metadata
    TASK_METADATA_ENVELOPE_KEYS.forEach(key => delete copy[key])
    return copy
  }

  const envelopeSchedule = metadata.schedule
  const { metadata: _nested, ...envelopeRest } = metadata

  const flattened = {
    ...envelopeRest,
    ...nested,
    schedule: nested.schedule ?? envelopeSchedule,
  }

  delete flattened.metadata
  TASK_METADATA_ENVELOPE_KEYS.forEach(key => delete flattened[key])

  return flattened
}

/** Convert task_name to mobile module (e.g. rapid_naming → RapidNaming). */
export const taskNameToModule = (taskName = '') => {
  if (!taskName) return undefined
  return taskName
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

/**
 * Restore mobile config.json contract fields stripped during flattening for the editor.
 */
export const enrichTaskMetadataForSave = (metadata = {}, { id, title, task_name } = {}) => {
  const resolvedTaskName = metadata.task_name || task_name
  return {
    ...metadata,
    ...(id ? { id } : {}),
    ...(title ? { title } : {}),
    module: metadata.module || taskNameToModule(resolvedTaskName),
  }
}
